import { aiChatModel } from 'shared/constants.json';

export const aiChatModelNames = {
  [aiChatModel.gpt5Mini]: 'GPT-5 mini',
  [aiChatModel.gpt5]: 'GPT-5',
  [aiChatModel.claudeHaiku45]: 'Claude Haiku 4.5',
  [aiChatModel.claudeSonnet5]: 'Claude Sonnet 5',
  [aiChatModel.claudeOpus5]: 'Claude Opus 5',
};

// mirrors brainstorm's app.yaml catalog, where haiku 4.5 is configured without effort because
// the API rejects it there
export const supportsEffort = (model) => model !== aiChatModel.claudeHaiku45;
